export const ADD_USERS_DATA_TEST_ID = 'button-add-user-to-site'
export const ADD_USERS_TEXT = 'Add Users'
export const SEND_INVITES_BUTTON_DATA_TEST_ID = 'button-send-invites'
export const SEND_INVITES_BUTTON_TEXT = 'Send Invites'
export const ROSTER_CANT_BE_ADDED_TEXT =
  'Contact your Rostering Administrator to add users to the site. Users can’t be added to rostered sites in User Management.'
